<template>
  <div class="remark_name">
    <van-popup
      v-model="remarkShow"
      get-container="remark_name"
      :close-on-click-overlay="false"
    >
      <div class="title">完善信息</div>
      <div class="remark_content">
        <div class="input">
          <div class="input_content">
            <label for="">真实姓名：</label>
            <div>
              <input
                type="text"
                maxlength="15"
                v-model.trim="remarkName"
                autocomplete="off"
              />
            </div>
          </div>
          <p v-if="joinType !== 1">请务必填写真实姓名用于审核</p>
        </div>
        <div class="button" @click="onSubmit">
          <van-button
            type="info"
            :class="!remarkName ? 'actived' : ''"
            native-type="submit"
            :disabled="!remarkName"
            >提交</van-button
          >
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { Popup as VanPopup, Button as VanButton } from "vant";
export default {
  props: {
    joinType: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      remarkName: "",
      remarkShow: false
    };
  },
  methods: {
    onSubmit() {
      this.$emit("remarkNameSuccess", this.remarkName);
      this.remarkShow = false;
    },
    init() {
      this.remarkShow = true;
      this.remarkName = "";
    }
  },
  components: { VanPopup, VanButton }
  // , VanField, VanForm, VanButton
};
</script>
<style lang="scss">
.remark_name {
  .van-popup {
    border-radius: 16px;
    width: 80%;
    overflow: hidden;
  }
  .title {
    padding-top: 26px;
    font-weight: 500;
    line-height: 24px;
    text-align: center;
    font-size: 16px;
    color: #323233;
  }
  .remark_content {
    .input {
      padding: 30px 10px;
      p {
        font-size: 12px;
        padding: 10px 12px 10px;
        margin: 0;
        color: #ccc;
        text-align: center;
      }
    }
    .input_content {
      display: flex;
      align-items: center;
      label {
        color: #646566;
        font-size: 14px;
        flex-shrink: 0;
      }
      div {
        flex: 1;
        display: flex;
        align-items: center;
        height: 38px;
        border-radius: 5px;
        border: 1px solid #ebedf0;
        input {
          width: 100%;
          border: none;
          outline: none;
          padding: 0 5px;
          color: #323233;
        }
      }
    }
    .button {
      height: 50px;
      text-align: center;
      border-top: 1px solid #ebedf0;
      .van-button {
        font-size: 16px;
        width: 100%;
        height: 100%;
        line-height: 50px;
        border: none;
        background: none;
        color: #4fc08d;
        &.actived {
          color: #ccc;
        }
      }
    }
    // .input {
    //   padding: 30px 0;
    // }
    // .van-cell {
    //   border: none;
    //   display: flex;
    //   align-items: center;
    //   .van-field__body {
    //     border: 1px solid #ebedf0;
    //   }
    //   line-height: 38px;
    //   input {
    //     height: 30px;
    //     padding: 0 5px;
    //     border-radius: 5px;
    //     outline: none;
    //   }
    // }
    // p {
    //   font-size: 12px;
    //   padding: 0 12px 10px;
    //   margin: 0;
    //   color: #ccc;
    //   text-align: center;
    // }
    // .van-cell:not(:last-child)::after {
    //   border: none;
    // }
    // .button {
    //   height: 40px;
    //   text-align: center;
    //   border-top: 1px solid #ebedf0;
    //   .van-button {
    //     font-size: 16px;
    //     width: 100%;
    //     height: 100%;
    //     line-height: 40px;
    //     border: none;
    //     background: none;
    //     color: #4fc08d;
    //     &.actived {
    //       color: #ccc;
    //     }
    //   }
    // }
  }
}
</style>
